import { useAuthStore } from 'stores/auth'
import { useTicketsStore } from 'stores/tickets'
import { useApprovalsStore } from 'stores/approvals'
import { useAccountStore } from 'stores/account'
import { useOnboardingActionsStore } from 'stores/onboarding/onboarding-actions'
import { themeService } from 'src/services/app/theme.service'

// List all your stores
export function resetStores() {
  const stores = [
    useAuthStore,
    useTicketsStore,
    useApprovalsStore,
    useAccountStore,
    useOnboardingActionsStore,
  ]

  // Keep redirect route for auth store
  const redirectRoute = useAuthStore().redirectRoute
  const theme = themeService.getCachedTheme()
  sessionStorage.clear()
  localStorage.clear()
  stores.forEach((storeInit) => {
    const store = storeInit()
    store.resetState?.()
  })
  useAuthStore().setRedirectRoute(redirectRoute)
  themeService.applyTheme(theme)
}
